import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["emailPrefix", "emailDomain", "senderEmail"];

  connect() {
    this.updateSenderEmail();
  }

  updateSenderEmail() {
    if (!this.hasEmailPrefixTarget || !this.hasEmailDomainTarget || !this.hasSenderEmailTarget)
      return;

    const localPart = this.emailPrefixTarget.value;
    const domain = this.emailDomainTarget.value;
    if (localPart && domain) {
      this.senderEmailTarget.value = `${localPart}@${domain}`;
    } else {
      this.senderEmailTarget.value = "";
    }
  }

  submit() {
    this.updateSenderEmail();
  }
}
